import { forwardRef, InputHTMLAttributes, PropsWithChildren } from 'react';
import styled, { css } from 'styled-components';
import { themeable } from './utils/colors';

type InputProps = InputHTMLAttributes<HTMLInputElement> &
  PropsWithChildren<{
    $size?: 'small' | 'medium' | 'large';
    $color?:
      | 'primary'
      | 'secondary'
      | 'success'
      | 'info'
      | 'warning'
      | 'danger';
    block?: boolean;
  }>;

const StyledInput = styled.input<InputProps>`
  width: ${({ block }) => (block ? '100%' : 'initial')};
  margin: 0;
  border: 2px solid ${({ theme }) => theme.colors.N20};
  border-radius: 2px;
  padding: 10px;
  font-size: 16px;
  font-family: inherit;
  color: ${({ theme }) => theme.colors.N40};

  &::-webkit-input-placeholder {
    color: ${({ theme }) => theme.colors.N50};
  }
  @media (max-width: ${({ theme }) => theme.breakpoint.md}) {
    flex-grow: 1;
  }

  // Color
  ${({ theme, $color }) => {
    const color = themeable(theme, $color);
    return css`
      border-color: ${color};
    `;
  }}
`;

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ $size, $color, block, ...rest }, ref) => {
    return (
      <StyledInput
        $size={$size}
        $color={$color}
        block={block}
        ref={ref}
        {...rest}
      />
    );
  }
);
